import React from 'react';
import cx from 'classnames';
import { SLDSMenuDropdown } from '@salesforce/design-system-react';

function DropdownMenu({
  className,
  triggerClassName,
  ...props
}) {
  return /*#__PURE__*/React.createElement(SLDSMenuDropdown, Object.assign({}, props, {
    triggerClassName: cx(triggerClassName, "tds-dropdown-trigger"),
    className: cx(className, "tds-dropdown")
  }));
}
DropdownMenu.displayName = "DropdownMenu";
DropdownMenu.propTypes = SLDSMenuDropdown.propTypes;
DropdownMenu.defaultProps = SLDSMenuDropdown.defaultProps;

export { DropdownMenu as default };
